import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import AddTimeLog from './AddTimeLog';

const TimeLog = () => {
    const { isSidebarOpen } = useSidebar();

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [activities, setActivities] = useState([
        {
            date: '2025-01-01',
            projectName: 'Project X',
            task: 'Development',
            timeSpent: '5 hours',
            notes: 'Urgent requirement',
            staff: 'John Doe',
        },
        {
            date: '2025-01-02',
            projectName: 'Project Y',
            task: 'Marketing',
            timeSpent: '3 hours',
            notes: 'Monthly campaign',
            staff: 'Jane Smith',
        },
    ]);
    const [filteredActivities, setFilteredActivities] = useState(activities);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = activities.filter((activity) =>
            Object.values(activity).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredActivities(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, activities]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredActivities.length / itemsPerPage);
    const currentData = filteredActivities.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = (indexToDelete) => {
        const updatedActivities = activities.filter((_, index) => index !== indexToDelete);
        setActivities(updatedActivities);
    };

    return (
        <>
           
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Time log</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add time log
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Activity Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Project Name</th>
                                <th>Task</th>
                                <th>Time Spent</th>
                                <th>Notes</th>
                                <th>Staff</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.date}</td>
                                        <td>{activity.projectName}</td>
                                        <td>{activity.task}</td>
                                        <td>{activity.timeSpent}</td>
                                        <td>{activity.notes}</td>
                                        <td>{activity.staff}</td>
                                        <td>
                                            <button className="view-button" onClick={() => setIsModalOpen(true)}>
                                                <i className="fa-solid fa-eye"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No data found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <AddTimeLog isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default TimeLog;
